import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      justifyItems: 'center',
      maxWidth: '26.25rem',
      textAlign: 'center',
      display: 'grid',
      gridGap: 20,
      padding: '1rem',
    },
  }),
);
